import React from "react"
import ReadMoreButton from "../readMoreButton";

const EntryComplete = props => {
    const { entryState } = props
    if (entryState && entryState.step === 'complete') {
        window.scroll({ top: 0, behavior: "auto" })
        return (
            <div className="contact-complete-wrap">
                <h3>送信が完了いたしました</h3>
                <p className="description">ご応募いただき、ありがとうございます。<br />
                    採用担当（メールアドレス）より数日以内にメールにてご連絡させていただきます。</p>
                <ReadMoreButton href="/" title="トップページ" />
            </div>
        )
    }
    return ""
}

export default EntryComplete
